const TokenKey = 'logintoken'

export function getToken() {
  return localStorage.getItem(TokenKey)
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  return localStorage.removeItem(TokenKey)
} 


// WEBPACK FOOTER //
// ./src/utils/auth.js